const features = [
  {
    key: "switches",
    unlimited: 2,
    plan: 1,
    sub: [
      {
        key: "discordControl",
        plan: 1,
        img: ["discordControl"],
      },
      {
        key: "customCommand",
        plan: 1,
        img: ["switchEdit"],
      },
      {
        key: "parent",
        plan: 2,
        img: ["switchEdit"],
      },
      {
        key: "autoOn",
        plan: 2,
        img: ["switchEdit"],
      },
      {
        key: "autoOff",
        plan: 3,
        img: ["switchEdit"],
      },
      {
        key: "samSite",
        plan: 3,
        img: ["switchEdit"],
      },
      {
        key: "autoLights",
        plan: 3,
        img: ["switchEdit"],
      },
    ],
  },
  {
    key: "alarms",
    unlimited: 2,
    plan: 1,
    sub: [
      {
        key: "ingameAlert",
        plan: 1,
        img: ["alarmMessage"],
      },
      {
        key: "discordAlert",
        plan: 2,
        img: ["alarmEdit"],
      },
    ],
  },
  {
    key: "storages",
    unlimited: 2,
    plan: 1,
    sub: [
      {
        key: "storageInsight",
        plan: 1,
        img: ["storages"],
      },
      {
        key: "decayAlert",
        plan: 1,
        img: ["buildingdecaying", "buildingdecaying2"],
      },
      {
        key: "upkeepTracker",
        plan: 2,
        img: ["upkeepdiscord", "upkeepdiscord2"],
      },
      {
        key: "scrapCalculator",
        plan: 3,
        img: ["scrapcalculator"],
      },
    ],
  },
  {
    key: "informations",
    plan: 1,
    sub: [
      {
        key: "serverInfos",
        plan: 1,
        img: ["discordserverinformations"],
      },
      {
        key: "eventsTimers",
        plan: 2,
        img: ["discordeventsinformation"],
      },
      {
        key: "eventsChannel",
        plan: 2,
        img: ["discordeventschannel"],
      },
      {
        key: "wipeAlert",
        plan: 2,
        img: ["justwiped"],
      },
      {
        key: "activityChannel",
        plan: 3,
        img: ["discordactivity"],
      },
    ],
  },
  {
    key: "commands",
    plan: 1,
    sub: [
      {
        key: "pop",
        plan: 1,
      },
      {
        key: "time",
        plan: 1,
      },
      {
        key: "talarm",
        plan: 2,
      },
      {
        key: "leader",
        plan: 2,
      },
    ],
    wikiHide: true,
  },
  {
    key: "statusTrack",
    plan: 2,
    sub: [
      {
        key: "afkDetector",
        show: true,
        plan: 2,
        img: ["afkDetector-afk", "afkDetector-back"],
      },
      {
        key: "connections",
        show: true,
        plan: 2,
        img: ["connected", "disconnected"],
      },
      {
        key: "trackDeaths",
        show: true,
        plan: 3,
        img: ["trackDeaths", "trackDeaths2", "trackDeaths3"],
      },
    ],
  },
  {
    key: "offlineKills",
    plan: 2,
    sub: [
      {
        key: "killsPm",
        plan: 2,
        img: ["offlinekill"],
      },
    ],
  },
  {
    key: "events",
    plan: 2,
    sub: [
      {
        key: "oilrigs",
        plan: 2,
        img: [
          "oilrigEvent-1",
          "oilrigEvent-2",
          "oilrigEvent-3",
          "oilrigEvent-4",
          "oilrigEvent-5",
        ],
      },
      {
        key: "patrol",
        plan: 2,
        img: ["patrolEvent-1"],
      },
      {
        key: "cargo",
        plan: 2,
        img: [
          "cargoEvent-1",
          "cargoEvent-2",
          "cargoEvent-3",
          "cargoEvent-4",
          "cargoEvent-5",
        ],
      },
      {
        key: "closeEvents",
        plan: 3,
      },
    ],
  },
  {
    key: "vendingSearch",
    plan: 2,
    sub: [
      {
        key: "vendingDiscord",
        plan: 2,
      },
      /*{
            key: 'vendingAlerts',
            plan: 3
        }*/
    ],
    wikiHide: true,
  },
  {
    key: "voice",
    plan: 3,
    sub: [
      {
        key: "voiceCommand",
        plan: 3,
      } /*,{
            key: 'customVoicePack',
            plan: 3
        },*/,
    ],
    wikiHide: true,
  },
  {
    key: "Rustlabs",
    plan: 1,
    sub: [
      {
        key: "cost",
        plan: 1,
      },
    ],
    wikiHide: true,
  },
  {
    key: "map",
    plan: 3,
    sub: [
      /*{
            key: 'mapGetTeammatesPosition',
            plan: 3,
        },
        {
            key: 'mapTrackPlayerMovements',
            plan: 3,
        },
        {
            key: 'mapTrackPlayerDeaths',
            plan: 3,
        },*/
      {
        key: "mapSearchItem",
        plan: 3,
      },
    ],
  },
  {
    key: "onlineChecker",
    plan: 3,
    sub: [
      {
        key: "onlineCreateLists",
        plan: 3,
      },
      {
        key: "onlineTrackUser",
        plan: 3,
      },
      {
        key: "onlineTrackGroup",
        plan: 3,
      },
    ],
    wikiHide: true,
  },
  {
    key: "hosted",
    plan: 1,
    wikiHide: true,
  },
];

export default features;
